
import { SendStoreLocatorForm, StoreLocatorTypeForm } from "@/interfaces";
import { defineComponent, PropType, reactive, ref } from "vue";
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default defineComponent({
  name: "ContactUsForm",
  emits: ["update:modelValue", "submit"],
  props: {
    modelValue: {
      type: Object as PropType<SendStoreLocatorForm>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const model = reactive<any>(
      props.modelValue || {
        name: "",
        lastname: "",
        email: "",
        telephone: "",
        province: "",
        city: "",
        organizationName: "",
        type: "",
        dealerType: StoreLocatorTypeForm.NoOne,
        notes: "",
      }
    );
    const checkboxes = reactive<any>({
      policy: false,
      terms: false,
    });

    const full = ref({ ...model, ...checkboxes });
    const rulesConfig = reactive<any>({
      name: {
        required,
      },
      lastname: {
        required,
      },
      email: {
        email,
        required
      },
      telephone: {
        required,
      },
      province: {
        required,
      },
      city: {
        required,
      },
      organizationName: {
        required,
      },
      type: {
        required,
      },
      policy: {
        requiredChecked: (val: any) => {
          return val === true;
        },
      }
    });
    const v$ = useVuelidate(rulesConfig, full);

    const onChange = (e: any) => {
      v$.value[e.target.name as any].$touch();
      full[e.target.name as any] = e.target.value;
      emit("update:modelValue", full);
    };

    const onSubmit = () => {
      emit("submit");
    };

    return {
      model: full,
      v$,
      onChange,
      onSubmit,
    };
  },
});
